import * as React from "react"
import { type VariantProps } from "class-variance-authority"

import { Button, buttonVariants } from "./ui/button"
import { cn } from "./ui/utils"

export interface SmartButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean,
  isActive?: boolean,
  isPending?: boolean
}

const FancyButton = React.forwardRef<HTMLButtonElement, SmartButtonProps>(
  ({ className, isActive, isPending, variant, size, asChild = false, ...props }, ref) => {
    let augmentedClassName = cn(buttonVariants({ variant, size, className }), "font-bold shadow-lg transform transition duration-300 hover:scale-105")
    if (!variant || variant === "default") {
      augmentedClassName = cn(augmentedClassName, "")
    } else if (variant === "link") {
      augmentedClassName = cn(augmentedClassName, "bg-transparent text-primary hover:bg-transparent hover:underline-0 shadow-none")
    } else if (variant === "outline") {
      augmentedClassName = cn(augmentedClassName, "bg-transparent border-2 border-primary-base text-primary-base")
    } else if (variant === "secondary") {
      augmentedClassName = cn(augmentedClassName, "shadow-none")
    } 
    if (size === "sm") {
      augmentedClassName += cn(augmentedClassName, "text-sm")
    } else if (size === "lg") {
      augmentedClassName += cn(augmentedClassName, "text-lg")
    }
    if (isPending) {
      augmentedClassName += cn(augmentedClassName, "pointer-events-none")
    }

    return (
      <Button
        className={augmentedClassName}
        ref={ref}
        {...props}
      />
    )
  }
)
FancyButton.displayName = "FancyButton"

export default FancyButton
